import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppVersionService } from '../../../../../services/app-version/app-version.service';

@Component({
  selector: 'app-update-overlay',
  templateUrl: './app-update-overlay.component.html',
  styleUrls: ['./app-update-overlay.component.css'],
  standalone: false,
})
export class AppUpdateOverlayComponent implements OnInit, OnDestroy {

  logoSrc = 'assets/logo-blau.png';
  progress = 0;

  private reloadTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private progressIntervalId: ReturnType<typeof setInterval> | null = null;
  private startTime = 0;
  private durationMs = 0;

  constructor(private appVersionService: AppVersionService) {}

  ngOnInit(): void {
    this.durationMs = this.appVersionService.getStoredUpdateDurationMs();
    this.startTime = Date.now();

    this.progressIntervalId = setInterval(() => this.tickProgress(), 80);

    this.reloadTimeoutId = setTimeout(() => {
      void this.reloadApp();
    }, this.durationMs);
  }

  ngOnDestroy(): void {
    if (this.reloadTimeoutId) {
      clearTimeout(this.reloadTimeoutId);
    }
    if (this.progressIntervalId) {
      clearInterval(this.progressIntervalId);
    }
  }

  private async reloadApp(): Promise<void> {
    this.progress = 100;
    await this.appVersionService.performHardReload();
  }

  private tickProgress(): void {
    const elapsed = Date.now() - this.startTime;
    this.progress = Math.min(100, (elapsed / this.durationMs) * 100);
  }

}
